import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button';
import { Link } from 'components/navigation/Link/Link';
import { ACTIONS } from 'types/mrph.pageName.constants';
import { Image } from 'components/Image/Image';
import './IncreaseScoreTips.scss';

const IncreaseScoreTipsView = props => {
  const { seenPixel, onLinkClick, userInfo } = props;
  const tip =
    'Tip: With a higher credit score you could potentially see lower interest rates';
  return (
    <SectionContainer className="padTB40 ">
      {seenPixel}
      <Row>
        <FlexContainer className="grayShadow16 pad16 borderRadius8 margB0 align-items-center justify-between t-block IncreaseScoreTips">
          <FlexContainer className="align-items-center m-margB24">
            <Image imgClass="lightbulbIcon width46px height46px" />
            <Label type="Subtitle-1 text-20 margL8 t-text-16 m-margl16">
              {tip}
            </Label>
          </FlexContainer>
          <Link
            to="/goals"
            location={ACTIONS}
            onClickCallback={onLinkClick}
            ariaLabel="See what you can do"
            isInline
          >
            <Button mrphType="primary" rounded className="padLR24 padTB12">
              See what you can do
            </Button>
          </Link>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default IncreaseScoreTipsView;
